import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

import Sidebar from '../sidebar/sidebar';
import AlertsBell from '../alertsBell/AlertsBell';

import { logout } from '../../../../services/auth/authService';

import environment from "../../../../environment/environment";

const Header = () => {
    const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const navigate = useNavigate();

    const toggleAccountMenu = () => {
        setIsAccountMenuOpen((status) => !status);
    };

    const toggleMenu = () => {
        setIsOpenMenu((status) => !status);
    }

    const signout = async () => {
        try {
            const response = await logout();

            if (response) {
                localStorage.clear();
                navigate('/');
            }
        } catch (error) {
            localStorage.clear();
            navigate('/');

            console.error('Error al cerrar sesión: ', error);
        }
    }

    return(
        <header className='bg-gray-800 max-h-[70px]'>
            <div className='max-w-screen-2xl mx-auto flex items-center justify-between py-2 px-10'>
                <Link to="/">
                    <Image width={60} height={35} src={environment.logoLight} alt="logo" className='w-20' />
                </Link>

                <div className='space-x-6 flex items-center group relative'>
                    <button id="toggleOpen" type='button' onClick={toggleMenu} className="lg:hidden block text-gray-50 hover:text-blue-600">
                        <span className="material-icons text-4xl flex items-center">menu</span>
                    </button>

                    <AlertsBell />

                    <div className="inline-block py-2">
                        <div className="flex cursor-pointer items-center text-gray-50 hover:text-blue-600" onClick={toggleAccountMenu}>
                            <span className='material-icons text-3xl'>person</span>
                            <span className={`material-icons transition-transform duration-300 
                                ${ isAccountMenuOpen ? 'rotate-180' : 'rotate-0'}`
                            }>keyboard_arrow_down</span>
                        </div>

                        {isAccountMenuOpen && (
                            <div className="fixed inset-0 z-10 h-full transition-opacity duration-500">
                                <div className="fixed inset-0 bg-black bg-opacity-50 border-b border-gray-200" onClick={toggleAccountMenu}></div>
                            </div>
                        )}

                        <div id="user-menu" className={`w-52 z-10 overflow-hidden transition-all duration-500 absolute right-0 mt-2 text-lg bg-white shadow-lg border border-gray-100 
                            ${isAccountMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
                        >
                            {/* <div className="px-4 pt-2 border-b border-gray-200">
                                <p className="text-sm font-semibold text-blue-600 mb-1">Perfil nombre</p>
                                <p className="text-sm text-gray-900 truncate">Email no disponible</p>
                            </div> */}

                            <div className="py-1 text-sm text-black">
                                <div>
                                    <button onClick={signout} className="flex w-full items-center px-4 py-2 hover:bg-gray-100 text-left">
                                        <span className="material-icons me-2 text-blue-600">logout</span> Cerrar sesión
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`
                fixed inset-0 z-10 transition-opacity duration-500"
                    ${isOpenMenu ? 'opacity-100 visible' : 'opacity-0 invisible'}
                `}>
                <div className="fixed inset-0 bg-black bg-opacity-50 border-b border-gray-200" onClick={toggleMenu}>
                </div>
            </div>

            <div className={
                `lg:hidden fixed left-0 top-0 bottom-0 z-10 bg-gray-50 w-[250px] shadow-lg h-full transition-transform duration-500 text-sm
                ${isOpenMenu ? 'translate-x-0' : '-translate-x-full'}
            `}>
                <div className={`flex flex-col h-full p-4`}>
                    {/* <div className="flex flex-wrap items-center justify-center cursor-pointer relative mt-4">
                        <Link to='/' onClick={toggleMenu}>
                            <Image width={192} height={98} src={logo} className="w-32" />
                        </Link>
                    </div> */}

                    {/* <hr className="my-6" /> */}

                    <Sidebar mobile={true} onClose={toggleMenu} />
                </div>
            </div>
        </header>
    );
}

export default Header;